module.exports = __webpack_public_path__ + "img/ic_smile.ec11b899.svg";